export default "__VITE_ASSET__KcCh9lEy__"